import { Button } from 'antd';
import { CopyableInput } from '../../../common/Inputs/CopyableInput';
import styles from '../UserProfile.module.scss';

interface ApiKeyInfoProps {
  downloaderApiKey?: string;
  readOnly?: boolean;
  requestApiKey?: () => void;
  isKeyValid?: boolean;
}

export const ApiKeyInfo = ({
  downloaderApiKey,
  readOnly,
  isKeyValid,
  requestApiKey,
}: ApiKeyInfoProps) => {
  if (readOnly) return null;

  const apiKeyStatusPart = (
    <div id="UserProfile-ApiKeyStatus_Text" className={styles.apiKeySection__info}>
      <div className={styles.apiKeySection__apiKey}>{'API key (Status '}</div>
      {isKeyValid ? (
        <b style={{ color: 'green' }}>valid</b>
      ) : (
        <b style={{ color: 'red' }}>expired</b>
      )}
      {')'}
    </div>
  );

  return (
    <div className={styles.additionalActions}>
      <div className={styles.apiKeyInfoInnerContainer}>
        <div className={styles.sectionHeader}>
          {downloaderApiKey && apiKeyStatusPart}
          <Button
            className={styles.requestApiKeyButton}
            type="primary"
            htmlType="button"
            id="UserProfile-RequestApiKey_Button"
            onClick={(e) => {
              e.preventDefault();
              requestApiKey?.();
            }}
          >
            {downloaderApiKey ? 'Renew' : 'Request'}
          </Button>
        </div>

        {downloaderApiKey && (
          <CopyableInput
            id="UserProfile-CopyApiKey_Input"
            copyButtonId="UserProfile-CopyApiKey_Button"
            value={downloaderApiKey}
          />
        )}
      </div>
    </div>
  );
};
